import RulesIcon from "./RulesIcon";
import BenchmarkIcon from "./BenchmarkIcon";
import TopicOperationsIcon from "./TopicOperationsIcon";
import PrivateCloudIcon from "./PrivateCloudIcon";
import ApproversIcon from "./ApproversIcon";
import SetsIcon from "./SetsIcon";
import ListViewIcon from "./ListViewIcon";
import PeopleIcon from "./PeopleIcon";
import DeleteTrashIcon from "./DeleteTrashIcon";
import LaptopIcon from "./LaptopIcon";
import WorkloadsIcon from "./WorkloadsIcon";
import TopicPolicyIcon from "./TopicPolicyIcon";
import DatePickerIcon from "./DatePickerIcon";
import StoreIcon from "./StoreIcon";
import TopicSystemIcon from "./TopicSystemIcon";
import TopicEnvironmentIcon from "./TopicEnvironmentIcon";
import RepositoriesIcon from "./RepositoriesIcon";
import FilterIcon from "./FilterIcon";
import ProcessesIcon from "./ProcessesIcon";
import DataIcon from "./DataIcon";
import TagsIcon from "./TagsIcon";
import ScanIcon from "./ScanIcon";
import InstallPolicyCloudIcon from "./InstallPolicyCloudIcon";
import TopicWelcomeIcon from "./TopicWelcomeIcon";
import CloudConfigIcon from "./CloudConfigIcon";
import ProfilesIcon from "./ProfilesIcon";
import CommitIcon from "./CommitIcon";
import EnforceIcon from "./EnforceIcon";
import AssetsIcon from "./AssetsIcon";
import NewComputerGroupIcon from "./NewComputerGroupIcon";
import AdminsIcon from "./AdminsIcon";
import DataSetIcon from "./DataSetIcon";
import ConfigurationIcon from "./ConfigurationIcon";
import SupportIcon from "./SupportIcon";
import EventsIcon from "./EventsIcon";
import FogsIcon from "./FogsIcon";
import NewIcon from "./NewIcon";
import TipsIcon from "./TipsIcon";
import HealthIcon from "./HealthIcon";
import UserIcon from "./UserIcon";
import PracticesIcon from "./PracticesIcon";
import AppIcon from "./AppIcon";
import WorldsIcon from "./WorldsIcon";
import TilesIcon from "./TilesIcon";
import OverviewIcon from "./OverviewIcon";
import LogsIcon from "./LogsIcon";
import ExpireOKIcon from "./ExpireOKIcon";
import ExpireDangerIcon from "./ExpireDangerIcon";
import ExpireWarningIcon from "./ExpireWarningIcon";
import CopyIcon from "./CopyIcon";
import TopicEvents from "./TopicEvents";
import TopicDeviceRisk from "./TopicDeviceRisk";
import TopicForensic from "./TopicForensic";
import TopicNetwork from "./TopicNetwork";
import TopicMobileDevices from "./TopicMobileDevices";
import FlowchartViewIcon from "./FlowchartViewIcon";
import AgentsIcon from "./AgentsIcon";
import LocationIcon from "./LocationIcon";
import JobsIcon from "./JobsIcon";
import ApproveIcon from "./ApproveIcon";
import RejectIcon from "./RejectIcon";
import AcceptIcon from "./AcceptIcon";
import FileCodeIcon from "./FileCodeIcon";
import FileNoneCopyIcon from "./FileNoneCopyIcon";
import FileNoneIcon from "./FileNoneIcon";
import FileUnknownIcon from "./FileUnknownIcon";
import UrlIcon from "./UrlIcon";
import PackagesIcon from "./PackagesIcon";
import IpsIcon from "./IpsIcon";
import CodeDiffIcon from "./CodeDiffIcon";
import FileScanIcon from "./FileScanIcon";
import DomainRecipientsIcon from "./DomainRecipientsIcon";
import EqualIcon from "./EqualIcon";
import NotEqualIcon from "./NotEqualIcon";
import InListIcon from "./InListIcon";
import NotInListIcon from "./NotInListIcon";
import FitIcon from "./FitIcon";
import IotIcon from "./IotIcon";
import NoResultsIcon from "./NoResultsIcon";
import BrandProtectionIcon from "./BrandProtectionIcon";
import TopicOverviewIcon from "./TopicOverviewIcon";
import IamProtection from "./IamProtection";
import PostureManagement from "./PostureManagement";
import TopicProfileIcon from "./TopicProfileIcon";
import SoftwareUpdateIcon from './SoftwareUpdateIcon'
import InfinityLogsIcon from "./InfinityLogsIcon";
import ServicesMenuInfinityIcon from "./ServicesMenuInfinityIcon"
import ServicesMenuQuantumIcon from "./ServicesMenuQuantumIcon"
import ServicesMenuCloudguardIcon from "./ServicesMenuCloudguardIcon"
import ServicesMenuHarmonyIcon from "./ServicesMenuHarmonyIcon"
import ServicesMenuLabsIcon from "./ServicesMenuLabsIcon"
import TopicWorkloadProtectionIcon from "./TopicWorkloadProtectionIcon";
import TopicLogsIcon from "./TopicLogsIcon";
import QuarantineIcon from "./QuarantineIcon";
import ServicesMenuInfinitySmallIcon from "./ServicesMenuInfinitySmallIcon";
import ServicesMenuQuantumSmallIcon from "./ServicesMenuQuantumSmallIcon";
import ServicesMenuCloudguardSmallIcon from "./ServicesMenuCloudguardSmallIcon";
import ServicesMenuHarmonySmallIcon from "./ServicesMenuHarmonySmallIcon";
import ServicesMenuLabsSmallIcon from "./ServicesMenuLabsSmallIcon";
import NewReportIcon from "./NewReportIcon";
import ReportIcon from "./ReportIcon";
import AddProfileIcon from "./AddProfileIcon";
import NoResultsFoundIcon from "./NoResultsFoundIcon";
import EmptyArrowIcon from "./EmptyArrowIcon";
import DataNotAvailableIcon from "./DataNotAvailableIcon";
import ContactExpertIcon from "./ContactExpertIcon";
import ContactExpertBigIcon from "./ContactExpertBigIcon";
import AccountTypeDistributerIcon from "./AccountTypeDistributerIcon";
import AccountTypeMsspIcon from "./AccountTypeMsspIcon";
import AccountTypeCustomerIcon from "./AccountTypeCustomerIcon";
import MessageIcon from "./MessageIcon";
import CalendarIcon from "./CalendarIcon";
import GoToIcon from "./GoToIcon";
import FeedbackIcon from "./FeedbackIcon";
import UpdatesIcon from "./UpdatesIcon";
import ContactSupportIcon from "./ContactSupportIcon";
import ServiceStatusIcon from "./ServiceStatusIcon";
import AdminGuideIcon from "./AdminGuideIcon";
import UnderAttackIcon from "./UnderAttackIcon";
import UserGroupsIcon from "./UserGroupsIcon";

export default {
  'iam-protection': IamProtection,
  'posture-management': PostureManagement,
  assets: AssetsIcon,
  "benchmark,topic-dashboard": BenchmarkIcon,
  "data-set": DataSetIcon,
  data: DataIcon,
  enforce: EnforceIcon,
  fogs: FogsIcon,
  health: HealthIcon,
  "install-policy-cloud": InstallPolicyCloudIcon,
  laptop: LaptopIcon,
  logs: LogsIcon,
  people: PeopleIcon,
  practices: PracticesIcon,
  repositories: RepositoriesIcon,
  rules: RulesIcon,
  scan: ScanIcon,
  support: SupportIcon,
  tags: TagsIcon,
  tips: TipsIcon,
  "environment,topic-environment": TopicEnvironmentIcon,
  "operationstopic-operations,operations": TopicOperationsIcon,
  "policy,topic-policy": TopicPolicyIcon,
  "system,topic-system": TopicSystemIcon,
  "topic-welcome": TopicWelcomeIcon,
  workloads: WorkloadsIcon,
  worlds: WorldsIcon,
  "delete-trash": DeleteTrashIcon,
  admins: AdminsIcon,
  "date-picker": DatePickerIcon,
  events: EventsIcon,
  filter: FilterIcon,
  new: NewIcon,
  store: StoreIcon,
  tiles: TilesIcon,
  user: UserIcon,
  approvers: ApproversIcon,
  overview: OverviewIcon,
  "private-cloud": PrivateCloudIcon,
  sets: SetsIcon,
  processes: ProcessesIcon,
  "cloud-config": CloudConfigIcon,
  profiles: ProfilesIcon,
  "new-computer-group": NewComputerGroupIcon,
  configuration: ConfigurationIcon,
  app: AppIcon,
  "expire-danger": ExpireDangerIcon,
  "expire-ok": ExpireOKIcon,
  "expire-warning": ExpireWarningIcon,
  copy: CopyIcon,
  topic_device_risk: TopicDeviceRisk,
  topic_forensic: TopicForensic,
  topic_events: TopicEvents,
  topic_network: TopicNetwork,
  topic_mobile_devices: TopicMobileDevices,
  flow_chart_view: FlowchartViewIcon,
  agents: AgentsIcon,
  "location,zones,zone": LocationIcon,
  jobs: JobsIcon,
  approve: ApproveIcon,
  "reject,block, drop, reject-colored": RejectIcon,
  "accept, accept-colored": AcceptIcon,
  file_code: FileCodeIcon,
  file_none: FileNoneIcon,
  file_none_copy: FileNoneCopyIcon,
  file_unknown: FileUnknownIcon,
  file_scan: FileScanIcon,
  "network.internet,url": UrlIcon,
  packages: PackagesIcon,
  ips: IpsIcon,
  code_diff: CodeDiffIcon,
  domain_recipients: DomainRecipientsIcon,
  "list-view": ListViewIcon,
  commit: CommitIcon,
  equal: EqualIcon,
  "not-equal": NotEqualIcon,
  "in-list": InListIcon,
  "not-in-list": NotInListIcon,
  fit: FitIcon,
  iot: IotIcon,
  "no-results": NoResultsIcon,
  "brand-protection": BrandProtectionIcon,
  "topic-overview": TopicOverviewIcon,
  "topic-profile": TopicProfileIcon,
  "software-update": SoftwareUpdateIcon,
  "infinity-logs": InfinityLogsIcon,
  "services-menu-infinity": ServicesMenuInfinityIcon,
  "services-menu-infinity-small": ServicesMenuInfinitySmallIcon,
  "services-menu-quantum": ServicesMenuQuantumIcon,
  "services-menu-quantum-small": ServicesMenuQuantumSmallIcon,
  "services-menu-cloudguard": ServicesMenuCloudguardIcon,
  "services-menu-cloudguard-small": ServicesMenuCloudguardSmallIcon,
  "services-menu-harmony": ServicesMenuHarmonyIcon,
  "services-menu-harmony-small": ServicesMenuHarmonySmallIcon,
  "services-menu-labs": ServicesMenuLabsIcon,
  "services-menu-labs-small": ServicesMenuLabsSmallIcon,
  "topic-logs": TopicLogsIcon,
  "topic-workload-protection": TopicWorkloadProtectionIcon,
  quarantine: QuarantineIcon,
  "new-report": NewReportIcon,
  "report": ReportIcon,
  "add-profile": AddProfileIcon,
  "no-results-found": NoResultsFoundIcon,
  'empty-arrow': EmptyArrowIcon,
  'data-not-available': DataNotAvailableIcon,
  'contact-expert': ContactExpertIcon,
  'contact-expert-big': ContactExpertBigIcon,
  'account-type-customer': AccountTypeCustomerIcon,
  'account-type-distributer': AccountTypeDistributerIcon,
  'account-type-mssp': AccountTypeMsspIcon,
  'message': MessageIcon,
  'calendar': CalendarIcon,
  'go-to': GoToIcon,
  'feedback': FeedbackIcon,
  'updates': UpdatesIcon,
  'admin-guide': AdminGuideIcon,
  'contact-support': ContactSupportIcon,
  'service-status': ServiceStatusIcon,
  'under-attack': UnderAttackIcon,
  'user-group': UserGroupsIcon,
};
